// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .dx-item.dx-toolbar-item.dx-toolbar-button.dx-scheduler-view-switcher.dx-toolbar-item-auto-hide {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/reservations/reservations.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF","sourcesContent":["// Hide View Selector\n::ng-deep .dx-item.dx-toolbar-item.dx-toolbar-button.dx-scheduler-view-switcher.dx-toolbar-item-auto-hide {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
